import React from "react";

export function Section({ children, className = "", id }) {
  return <section id={id} className={`mx-auto max-w-7xl px-4 sm:px-6 ${className}`}>{children}</section>;
}

export function Eyebrow({ children }) {
  return <p className="text-xs font-semibold uppercase tracking-[0.18em] text-clinical" data-testid="eyebrow">{children}</p>;
}

export function PageHero({ eyebrow, title, subtitle, image, children }) {
  return (
    <div className="relative overflow-hidden bg-navy">
      {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      <div className={`relative ${image ? "cpp-hero-overlay" : ""}`}>
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-28">
          <div className="max-w-3xl cpp-fade-up">
            {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.18em] text-clinical">{eyebrow}</p>}
            <h1 className="mt-4 font-heading text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">{title}</h1>
            {subtitle && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-300">{subtitle}</p>}
            {children && <div className="mt-8">{children}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
